"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.form = void 0;
const stitches_config_1 = require("../../../stitches.config");
exports.form = (0, stitches_config_1.css)({
    "#root": {
        border: "none",
        padding: 0,
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRm9ybS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL2NvbXBvbmVudHMvU3VibWlzc2lvbnMvX19zdHlsZXNfXy9Gb3JtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLDhEQUErQztBQUVsQyxRQUFBLElBQUksR0FBRyxJQUFBLHFCQUFHLEVBQUM7SUFDdEIsT0FBTyxFQUFFO1FBQ1AsTUFBTSxFQUFFLE1BQU07UUFDZCxPQUFPLEVBQUUsQ0FBQztLQUNYO0NBQ0YsQ0FBQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSBcIi4uLy4uLy4uL3N0aXRjaGVzLmNvbmZpZ1wiO1xuXG5leHBvcnQgY29uc3QgZm9ybSA9IGNzcyh7XG4gIFwiI3Jvb3RcIjoge1xuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgcGFkZGluZzogMCxcbiAgfSxcbn0pO1xuIl19